/**
 * Enum correspondente aos tipo de acordos
 */
export enum TipoAcordoEnum {

    ACORDO_INTERNO                  = 1,
    ACORDO_SEM_SINISTRO             = 2,
    COBRANCA_AREA_TECNICA           = 3,
    DEVOLUCAO                       = 4,
    FIANCA                          = 5,
    IPVA                            = 6,
    MULTA                           = 7,
    REPETICAO_DE_INDEBITO           = 8,
    RESSARCIMENTO_AUTO              = 9,
    RESSARCIMENTO_RE                = 10,
    COBRANCA_ADVOCACIA              = 11,
    COBRANCA_RESSARCIMENTO_FIANCA   = 12,
    COBRANCA_AREA_TECNICA2          = 13 //TODO verificar pois esta duplicada com o codigo 3 
}
